import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LandingpageDialogComponent } from '../landingpage-dialog/landingpage-dialog.component';
import { Store } from '@ngrx/store';
import { loadLandingPage, viewLoadLandingPage } from '../../action/landingpage.action';
import { Observable } from 'rxjs';
import { landingpage } from '../../model/landingpage';
import { selectLandingPageData } from '../../reducer/landingpage.reducer';
import { Router } from '@angular/router';


@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrl: './template-list.component.scss'
})
export class TemplateListComponent implements OnInit {

  templates = ['Template_1', 'Template_2', 'Template_3', 'Template_4', 'Template_5'];
  selectedCard: string = '';
  Template_1:boolean=false;
  gifLoader:boolean=true;
  landingPageData:any;
  constructor(private dialog:MatDialog,private store:Store,private router: Router){
    this.store.dispatch(viewLoadLandingPage());
    // this.landingPageData$ = this.store.select(selectLandingPageData);
    // console.log(this.landingPageData$,'this.landingPageData$')
    this.store.select(selectLandingPageData).subscribe((data: any[]) => {
      if(data){
        this.gifLoader=false;
        this.landingPageData = data; // Store in a normal variable
        console.log('Landing Page Data:', this.landingPageData);
      }

    });
  }
  selectCard(cardId: string) {
    this.selectedCard = cardId;
  }
  ngOnInit() {

  }
  AddTempate(name:any){
    if(name=='Template_1'){
    const dialogRef=this.dialog.open(LandingpageDialogComponent,{
        width:'1100px',
        // data:name

      })
      dialogRef.afterClosed().subscribe((data)=>{
        if(data){
          console.log(data);
        }
      })
    }
  }

  changeTemplate(data:any){
    let value=data.value
    if(value=="Template_1"){
      this.Template_1=true;
    }else{
      this.Template_1=false;
    }
 }
 viewPage(page: any) {
  this.router.navigate(['/landingpage-one', page.seo_url_name], { state: { page } });
}
editPage(page:any){
  const dialogRef=this.dialog.open(LandingpageDialogComponent,{
    width:'1100px',
    data:page

  })
  dialogRef.afterClosed().subscribe((data)=>{
    if(data){
      console.log(data);
    }
  })
}
deleteData(data: any) {
  const dataArray = Array.isArray(data) ? data : [data];
  const updatedData = dataArray.map(d => ({ ...d, status: 1 }));
   this.store.dispatch(loadLandingPage({landingpage:updatedData[0]}));
  //  this.store.dispatch(viewLoadLandingPage());
}


}
